import { useEffect, useState } from "react";
import {  useSelector } from "react-redux";
import Overlay from "../../components/NoDataFoundPage/NoDataFoundPage";
import { LoadingAnimation } from "../../components/Loading/LoadingAnimation";
import { selectLogInUsername, selectUserStatus } from "../../common/authenticateDashboard/authSlice";
import { SalesSummary, TopKTrafficSources } from "./components";
import TopUsers from "./components/TopUsers";

const CohortInsights = () => {
  const [loading, setLoading] = useState(true);
  const [optimizerStatus, setOptimizerStatus] = useState(false);

  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser.split("@")[0];
  const userStatus = useSelector(selectUserStatus)

  useEffect(() => {
    if (userStatus?.funnel_optimizer) setOptimizerStatus(true);
    setLoading(false);
  }, [userStatus])


  if (loading === true) {
    return <LoadingAnimation />;
  }

  return (
    <>
      {optimizerStatus ? (
        <div className="flex-grow p-4" style={{ width: "75%" }}>
        <div className="flex flex-col mt-4">
            <SalesSummary/>
            <TopKTrafficSources/>
            <TopUsers/>
          </div>
        </div>
      ) : (
        <Overlay />
      )}
    </>
  );
};

export default CohortInsights;
